import React, { useEffect, useState } from "react";
import "../Table/Table.css";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Loading from "../Loading";
import DataTable from "../DataTable/DataTable";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { Box, Button, Typography, TextField, Modal } from "@mui/material";
import { useVendor } from "../../utils/Context";
import { clearAuthData } from "../../utils/AuthStorage";
import { useNavigate } from "react-router-dom";
import { getPermissionByPrefix } from "../../utils/permissions";
import { useErrorToast } from "../../hooks/useErrorToast";

function Vendor() {
  const showError = useErrorToast();
  const navigate = useNavigate();
  const [contracts, setContracts] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [loadingFull, setLoadingFull] = useState(false);
  const [contractLoading, setContractLoading] = useState(true);
  const {
    vendors,
    setVendors,
    setSelectedVendor: setVendorInContext,
  } = useVendor();
    const { is_view, is_add, is_edit, is_delete } = getPermissionByPrefix("manage_vendor");

  useEffect(() => {
    handleVendor();
  }, []);

  const handleVendor = async () => {
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(`${process.env.REACT_APP_URL}/vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      setContracts(response.data);
      if (response.data.length > 0) {
        setSelectedVendor(response.data[0].id);
      }
      if (response.data.length == 0) {
        setSelectedVendor(-1);
      }
      setVendors(response.data);
      setEditModal(false);
      setDeleteModal(false);
      setSelectedVendor({});
      setAddModal(false);
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        clearAuthData();
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error || "Something went wrong. Please try again."
        // );
      }
    } finally {
      setContractLoading(false);
      setLoadingFull(false);
    }
  };

  const handleAddVendor = async () => {
    if (!selectedVendor?.name || !selectedVendor?.contact) {
      toast.error("Please fill all fields");
      return;
    }
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/vendor`,
        selectedVendor,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      handleVendor();
    } catch (error) {
      console.log("Failed Fetching SOF", error.response.status);
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        clearAuthData();
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error || "Something went wrong. Please try again."
        // );
      }
      setContractLoading(false);
      setLoadingFull(false);
    }
  };
  const handleEditVendor = async () => {
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/vendor/${selectedVendor.id}`,
        selectedVendor,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      handleVendor();
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        clearAuthData();
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error || "Something went wrong. Please try again."
        // );
      }
      setContractLoading(false);
      setLoadingFull(false);
    }
  };
  const handleDeleteVendor = async () => {
    setContractLoading(true);
    setLoadingFull(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/vendor/${selectedVendor.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "true",
          },
        }
      );
      handleVendor();
    } catch (error) {
      if (error.response.status === 401) {
        showError("Session Expired! Please Login");
        clearAuthData();
        navigate("/");
      } else {
        showError(error?.response?.data?.error || "Something went wrong. Please try again.");
        // toast.error(
        //   error.response.data.error || "Something went wrong. Please try again."
        // );
      }
      setContractLoading(false);
      setLoadingFull(false);
    }
  };
  const columns = [
    { field: "name", headerName: "Vendor Name", width: 150 },
    { field: "contact", headerName: "Vendor Contact", width: 150 },
    { field: "status", headerName: "Status", width: 150 },
    {
      field: "actions",
      headerName: "",
      width: 250,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              display: "flex",
              gap: "10px",
            }}
          >
           {is_edit && ( <Button
              variant="contained"
              onClick={() => {
                setSelectedVendor(params.row);
                setEditModal(true);
              }}
              sx={{
                fontSize: "12px",
                marginLeft: "5px",
                display: "flex",
                marginTop: "7px",
                backgroundColor: "rgb(124, 46, 160)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <FaEdit color="#FFF" size={20} title="Edit" />
              </div>
            </Button>)}
           {is_delete && ( <Button
              variant="contained"
              onClick={() => {
                setSelectedVendor(params.row);
                setDeleteModal(true);
              }}
              sx={{
                fontSize: "12px",
                marginLeft: "5px",
                display: "flex",
                marginTop: "7px",
                backgroundColor: "rgb(124, 46, 160)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <FaTrash color="#FFF" size={20} title="Edit" />
              </div>
            </Button>)}
          </Box>
        );
      },
    },
  ];

  
      if (!is_view) {
  return <div>You do not have permission to view this page.</div>;
}

  return (
    <div style={profileStyle}>
      <Toaster position="top-right" reverseOrder={false} style={{ zIndex: "9999999" }}/>
      {loadingFull && <Loading />}
      <div className="table-header">
        <h2>Vendors</h2>
        {is_add && (
        <button className="upload-button" onClick={() => setAddModal(true)}>
          <FaPlus
            style={{
              marginRight: "5px",
            }}
          />
          Add Vendor
        </button>)}
      </div>
      <div style={{ marginBottom: "30px" }}>
        <DataTable columns={columns} rows={contracts} />
      </div>

      {/* Add Modal; */}
      <Modal
        open={addModal}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            setAddModal(false);
            setSelectedVendor({});
          }
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Add Vendor
          </Typography>

          <TextField
            fullWidth
            label="Vendor Name"
            variant="outlined"
            required
            name="name"
            value={selectedVendor?.name}
            onChange={(e) => {
              setSelectedVendor((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <TextField
            fullWidth
            label="Vendor Contact"
            variant="outlined"
            required
            name="contact"
            value={selectedVendor?.contact}
            onChange={(e) => {
              setSelectedVendor((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                handleAddVendor();
              }}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                setAddModal(false);
                setSelectedVendor({});
              }}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Edit Modal; */}
      <Modal
        open={editModal}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            setEditModal(false);
            setSelectedVendor({});
          }
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Edit Vendor
          </Typography>

          <TextField
            fullWidth
            label="Vendor Name"
            variant="outlined"
            required
            name="name"
            value={selectedVendor?.name}
            onChange={(e) => {
              setSelectedVendor((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <TextField
            fullWidth
            label="Vendor Contact"
            variant="outlined"
            required
            name="contact"
            value={selectedVendor?.contact}
            onChange={(e) => {
              setSelectedVendor((prevState) => {
                let temp = { ...prevState };
                temp[e.target.name] = e.target.value;
                return temp;
              });
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                handleEditVendor();
              }}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                setEditModal(false);
                setSelectedVendor({});
              }}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Delete Modal  */}
      <Modal
        open={deleteModal}
        onClose={(e, reason) => {
          if (reason !== "backdropClick") {
            setDeleteModal(false);
            setSelectedVendor({});
          }
        }}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            width: 400,
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontSize: "24px",
              marginBottom: "15px",
              marginTop: "10px",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete vendor <b>{selectedVendor?.name}</b>
            ?
          </Typography>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              onClick={() => {
                handleDeleteVendor();
              }}
              style={{
                flex: 1,
                marginRight: "10px",
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => {
                setDeleteModal(false);
                setSelectedVendor({});
              }}
              style={{
                flex: 1,
                fontSize: "18px",
                background: "#7C2EA0",
                color: "white",
                padding: "12px",
              }}
            >
              Cancel
            </Button>
          </div>
        </Box>
      </Modal>

      <div id="scroll-to-bottom"></div>
    </div>
  );
}
const profileStyle = {
  // width: "90%",
  background: "#fff",
  borderRadius: "8px",
  marginInline: "16px",
  marginTop: "20px",
  padding: "20px",
};
export default Vendor;
